import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Notification } from 'src/app/core/models/notification-pg';
import { TranslateParser } from '@ngx-translate/core';
import { ContextService } from '@core/services/core/context.service';
@Component({
  selector: 'mapfre-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotificationComponent {
  @Input() data: Notification;
  @Output() close = new EventEmitter();
  @Output() action = new EventEmitter();
  @Output() later = new EventEmitter();

  constructor(
    public ctx: ContextService,
    private transParser: TranslateParser
  ) {}

  get text() {
    if (!this.data) { return ''; }
    return this.transParser.interpolate(this.data.text, this.data.interpolationParams);
  }

  onClose() {
    this.close.emit('close');
  }

  onAction() {
    this.action.emit('action');
  }

  onLater() {
    this.later.emit('later');
  }
}
